<template>
  <v-container v-resize="checkMobile" data-testid="profile-page">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-card>
      <!-- <v-card-title>
        <h2>{{ $t("custom.profile") }} {{ user.name }}</h2>
        <v-icon class="ml-2 green--text" @click="saveUser()">
          mdi-content-save-all-outline
        </v-icon>
      </v-card-title> -->

      <v-card-text>
        <v-container grid-list-md>
          <!-- Аватар и имя -->
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 class="text-center">
              <v-flex xs12 sm12 md12>
                <v-avatar size="150px" color="blue" v-if="user" class="UppyModalOpenerBtn" style="cursor: pointer;">
                  <v-img
                    v-if="!isNative && user && user.avatar_url && !avatarFailed"
                    :src="user.avatar_url"
                    :alt="user.name"
                    class="grey lighten-2"
                    @error="avatarFailed = true"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                  <span v-else class="white--text text-h5">{{
                    user && user.name && user.name[0]
                      ? user.name[0]
                      : (user && user.email ? user.email[0] : '?')
                  }}</span>
                </v-avatar>
              </v-flex>
              <v-flex v-if="user.name" xs12 sm12 md12>
                <h2>{{ user.name }}</h2>
              </v-flex>
            </v-flex>
            <v-flex xs12 sm12 md12 class="my-2 d-flex justify-center">
              <uppy-user-avatar
                :max-file-size-in-bytes="50000000"
                :width="isMobile ? '300' : '750'"
                :height="isMobile ? 250 : 250"
                :theme="$vuetify.theme.dark ? 'dark' : 'light'"
                :user_id="user.id"
                @uploaded="(url) => { avatarFailed = false; $set(user, 'avatar_url', url) }"
              ></uppy-user-avatar>
            </v-flex>
          </v-layout>

          <!-- Вкладки -->
          <v-tabs 
            v-model="activeTab" 
            class="mt-4" 
            background-color="transparent" 
            color="primary" 
            :vertical="isMobile"
            :centered="!isMobile"
          >
            <v-tab>
              <v-icon left>mdi-account</v-icon>
              <span class="ml-2">{{ $t("custom.profile") }}</span>
            </v-tab>
            <v-tab>
              <v-icon left>mdi-shield-lock</v-icon>
              <span class="ml-2">{{ $t("custom.security") }}</span>
            </v-tab>
            <v-tab>
              <v-icon left>mdi-account-group</v-icon>
              <span class="ml-2">{{ $t("employers.partner_program") }}</span>
            </v-tab>
            <v-tab>
              <v-icon left>mdi-cog</v-icon>
              <span class="ml-2">{{ $t("user_settings.settings") }}</span>
            </v-tab>
            <!-- FT-155: персональные ключи агента (MCP); партнёрам и агентам ключи не выпускаются -->
            <v-tab v-if="canHaveAgentTokens">
              <v-icon left>mdi-robot-outline</v-icon>
              <span class="ml-2">{{ $t("agent_tokens.tab_title") }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="activeTab">
            <!-- Вкладка 1: Профиль -->
            <v-tab-item>
              <v-layout row wrap class="mt-4" id="registration-step-6">
                <v-flex xs12 sm12 md4 id="registration-step-2">
                  <v-text-field
                    v-model.trim="user.email"
                    :label="$t('custom.email')"
                    :disabled="true"
                    type="text"
                    outlined
                  >
                    <template v-slot:append>
                      <!-- Адрес отклонён Postmark (invalid_email): письма не доставляются -->
                      <v-icon v-if="user.invalid_email" color="warning" v-tooltip="{
                        content: $t('custom.invalid_email_tooltip'),
                        placement: 'bottom-center',
                        classes: ['info'],
                        targetClasses: ['it-has-a-tooltip'],
                      }">mdi-email-alert-outline</v-icon>
                    </template>
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <phone-field
                    ref="phoneField"
                    :label="$t('users.phone')"
                    v-model="user.phone"
                    mode="strict"
                    :default-country="phoneDefaultCountry"
                    :needs-check="!!user.phone_needs_check"
                    outlined
                    data-testid="profile-phone-field"
                  />
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field
                    :label="$t('users.tg_id')"
                    v-model.trim="user.telegram_id"
                    type="text"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    :label="$t('employers.nickname')"
                    type="text"
                    v-model.trim="user.name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    :label="$t('employers.name')"
                    type="text"
                    v-model.trim="user.first_name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    :label="$t('employers.middle_name')"
                    type="text"
                    v-model.trim="user.middle_name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md3>
                  <v-text-field
                    :label="$t('employers.last_name')"
                    type="text"
                    v-model.trim="user.last_name"
                    outlined
                  ></v-text-field>
                </v-flex>
                <v-flex md12 sm12>
                  <v-select
                    v-model="select_locale"
                    class="mb-2"
                    item-text="text"
                    item-value="value"
                    :items="locales"
                    :label="$t('companies.locale_front')"
                    outlined
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <!-- Вкладка 2: Безопасность -->
            <v-tab-item>
              <v-layout row wrap class="mt-4 px-2 px-sm-0">
                <!-- Смена пароля -->
                <v-flex md6 xs12 class="pr-md-4 mb-4 mb-md-0">
                  <p class="subtitle-1 mb-2">{{ $t("account_security.change_password") }}</p>
                  <v-text-field
                    v-model="passwordForm.current"
                    :label="$t('account_security.current_password')"
                    :type="showCurrentPassword ? 'text' : 'password'"
                    :append-icon="showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showCurrentPassword = !showCurrentPassword"
                    outlined
                    dense
                    autocomplete="current-password"
                  ></v-text-field>
                  <v-text-field
                    v-model="passwordForm.new"
                    :label="$t('account_security.new_password')"
                    :type="showNewPassword ? 'text' : 'password'"
                    :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="showNewPassword = !showNewPassword"
                    :rules="newPasswordTouched ? passwordRules : []"
                    @blur="newPasswordTouched = true"
                    @input="passwordForm.new && (newPasswordTouched = true)"
                    outlined
                    dense
                    autocomplete="new-password"
                  ></v-text-field>
                  <v-text-field
                    v-model="passwordForm.confirm"
                    :label="$t('account_security.confirm_password')"
                    :type="showNewPassword ? 'text' : 'password'"
                    :error="passwordConfirmTouched && passwordForm.new && passwordForm.confirm && passwordForm.new !== passwordForm.confirm"
                    :error-messages="passwordConfirmTouched && passwordForm.new && passwordForm.confirm && passwordForm.new !== passwordForm.confirm ? $t('account_security.passwords_not_match') : ''"
                    @blur="passwordConfirmTouched = true"
                    @input="passwordForm.confirm && (passwordConfirmTouched = true)"
                    outlined
                    dense
                    autocomplete="new-password"
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    :loading="passwordChanging"
                    :disabled="!canChangePassword"
                    :block="isMobile"
                    @click="changePassword()"
                  >
                    {{ $t("account_security.change_password_btn") }}
                  </v-btn>
                </v-flex>
                
                <!-- Смена email -->
                <v-flex md6 xs12 class="pl-md-4 mt-4 mt-md-0">
                  <v-divider class="mb-4 d-md-none"></v-divider>
                  <p class="subtitle-1 mb-2">{{ $t("account_security.change_email") }}</p>
                  
                  <template v-if="!emailChangeRequested">
                    <v-text-field
                      :value="user.email"
                      :label="$t('account_security.current_email')"
                      outlined
                      dense
                      disabled
                      class="mb-0"
                    ></v-text-field>
                    <v-text-field
                      v-model="emailForm.password"
                      :label="$t('account_security.current_password')"
                      :type="showEmailPassword ? 'text' : 'password'"
                      :append-icon="showEmailPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showEmailPassword = !showEmailPassword"
                      outlined
                      dense
                      autocomplete="current-password"
                    ></v-text-field>
                    <v-text-field
                      v-model="emailForm.newEmail"
                      :label="$t('account_security.new_email')"
                      type="email"
                      :rules="emailRules"
                      outlined
                      dense
                      autocomplete="email"
                    ></v-text-field>
                    <v-btn
                      color="primary"
                      :loading="emailChanging"
                      :disabled="!canRequestEmailChange"
                      :block="isMobile"
                      @click="requestEmailChange()"
                    >
                      {{ $t("account_security.send_code") }}
                    </v-btn>
                  </template>
                  
                  <template v-else>
                    <v-alert type="info" text dense class="mb-3">
                      {{ $t("account_security.code_sent_to", { email: emailForm.maskedEmail }) }}
                    </v-alert>
                    <v-text-field
                      v-model="emailForm.code"
                      :label="$t('account_security.confirmation_code')"
                      outlined
                      dense
                      maxlength="6"
                    ></v-text-field>
                    <div :class="isMobile ? '' : 'd-flex'">
                      <v-btn
                        color="primary"
                        :loading="emailChanging"
                        :disabled="!emailForm.code || emailForm.code.length !== 6"
                        :block="isMobile"
                        @click="confirmEmailChange()"
                        :class="isMobile ? 'mb-2' : 'mr-2'"
                      >
                        {{ $t("account_security.confirm") }}
                      </v-btn>
                      <v-btn
                        text
                        :block="isMobile"
                        @click="cancelEmailChange()"
                      >
                        {{ $t("custom.cancel") }}
                      </v-btn>
                    </div>
                  </template>
                </v-flex>
                
                <v-flex xs12>
                  <v-divider class="my-4"></v-divider>
                </v-flex>
                
                <!-- Passkeys -->
                <v-flex xs12>
                  <p class="subtitle-1 mb-2">{{ $t("passkeys.title") }}</p>
                  <p class="body-2 text--secondary mb-3">{{ $t("passkeys.description") }}</p>
                  
                  <!-- Если WebAuthn не поддерживается браузером/устройством -->
                  <v-alert v-if="!passkeySupported" type="warning" text dense class="mb-3">
                    {{ $t("passkeys.not_supported") }}
                  </v-alert>
                  
                  <template v-if="passkeySupported">
                  
                  <v-list v-if="passkeys.length > 0" dense class="mb-3 passkey-list">
                    <v-list-item v-for="passkey in passkeys" :key="passkey.id" class="px-0">
                      <v-list-item-content>
                        <v-list-item-title class="d-flex align-center">
                          <span>{{ passkey.nickname || $t("passkeys.unnamed") }}</span>
                          <v-spacer></v-spacer>
                          <v-btn 
                            icon 
                            x-small 
                            color="error" 
                            @click="deletePasskey(passkey)"
                            :loading="passkeyDeleting === passkey.id"
                            class="ml-2"
                          >
                            <v-icon small>mdi-delete</v-icon>
                          </v-btn>
                        </v-list-item-title>
                        <v-list-item-subtitle class="text-wrap">
                          {{ formatDate(passkey.created_at) }}
                          <template v-if="passkey.last_used_at && !isMobile"> • {{ $t("passkeys.last_used") }}: {{ formatDate(passkey.last_used_at) }}</template>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  
                  <v-alert v-else type="info" text dense class="mb-3">
                    {{ $t("passkeys.no_passkeys") }}
                  </v-alert>
                  
                  <v-btn 
                    color="primary" 
                    outlined
                    :small="!isMobile"
                    :block="isMobile"
                    :loading="passkeyRegistering"
                    :disabled="!passkeyPlatformAvailable"
                    @click="registerPasskey()"
                  >
                    {{ $t("passkeys.add_passkey") }}
                  </v-btn>
                  
                  <p v-if="!passkeyPlatformAvailable" class="caption text--secondary mt-2">
                    {{ $t("passkeys.not_supported_device") }}
                  </p>
                  </template>
                </v-flex>

                <v-flex xs12>
                  <v-divider class="my-4"></v-divider>
                </v-flex>

                <!-- Запомнить логин -->
                <v-flex xs12>
                  <v-switch
                    v-model="user_setting.remember_login"
                    :label="$t('custom.remember_login')"
                    :hint="$t('custom.remember_login_hint')"
                    persistent-hint
                    dense
                    hide-details="auto"
                    class="mt-0"
                    style="max-width: 400px"
                    @change="saveRememberLogin"
                  ></v-switch>
                </v-flex>
                
                <v-flex xs12>
                  <v-divider class="my-4"></v-divider>
                </v-flex>

                <!-- Выход со всех устройств -->
                <v-flex xs12>
                  <p class="subtitle-1 mb-1">{{ $t("account_security.invalidate_all_sessions") }}</p>
                  <p class="body-2 text--secondary mb-3">{{ $t("account_security.invalidate_all_sessions_description") }}</p>
                  <v-btn
                    color="error"
                    outlined
                    :small="!isMobile"
                    :block="isMobile"
                    :loading="invalidatingSessions"
                    @click="invalidateAllSessions()"
                  >
                    <v-icon left small>mdi-logout</v-icon>
                    {{ $t("account_security.invalidate_all_sessions") }}
                  </v-btn>
                </v-flex>

                <v-flex v-if="main_company.beacons_on && !isAgent" xs12>
                  <v-divider class="my-4"></v-divider>
                </v-flex>
                
                <!-- Пароль трекера -->
                <v-flex v-if="main_company.beacons_on && !isAgent" xs12>
                  <p class="subtitle-1 mb-2">{{ $t("cars.traccar_service") }}</p>
                  <v-text-field
                    v-model="user.traccar_password"
                    :label="$t('cars.traccar_password')"
                    type="password"
                    autocomplete="off"
                    outlined
                    dense
                    style="max-width: 400px"
                  ></v-text-field>
                </v-flex>
                <!-- FT-191: PIN для общих компьютеров компании (только сотрудники) -->
                <v-flex v-if="canHavePin" xs12 class="mt-4" style="max-width: 400px">
                  <p class="subtitle-1 mb-2">{{ $t("pin_settings.title") }}</p>
                  <p class="text--secondary">{{ $t("pin_settings.description") }}</p>
                  <pin-form allow-reset />
                </v-flex>
              </v-layout>
            </v-tab-item>

            <!-- Вкладка 3: Партнерская программа -->
            <v-tab-item>
              <v-layout row wrap class="mt-4">
                <v-flex md12 sm12>
                  <v-alert
                    color="primary"
                    border="left"
                    colored-border
                    elevation="1"
                    class="mb-4"
                  >
                    <div class="d-flex align-start">
                      <div>
                        <h3 class="mb-2">{{ $t("employers.partner_program") }}</h3>
                        <p class="body-2 mb-2">{{ $t("employers.partner_program_description") }}</p>
                        <v-btn
                          text
                          small
                          color="primary"
                          :href="$t('employers.partner_program_policy_link')"
                          target="_blank"
                          class="px-0"
                        >
                          <v-icon left small>mdi-file-document-outline</v-icon>
                          {{ $t("employers.partner_program_policy_link_text") }}
                        </v-btn>
                      </div>
                    </div>
                  </v-alert>
                </v-flex>

              <v-flex md12 sm12>
                <v-text-field
                v-model="referral_link"
                :label="$t('employers.referral_link')"
                type="text"
                readonly
                outlined
                hide-details
              >
              <v-icon
                slot="append"
                :color="referral_link ? 'green' : 'grey'"
                @click="copyReferralLink()"
                cursor="pointer"
              >
                mdi-content-copy
              </v-icon>
              </v-text-field>
            </v-flex>
            <v-flex md12 sm12>
              <v-text-field
                v-model="referral_link_landing"
                :label="$t('employers.referral_link_landing')"
                type="text"
                readonly
                outlined
                hide-details
              >
              <v-icon
                slot="append"
                :color="referral_link_landing ? 'green' : 'grey'"
                @click="copyReferralLinkLanding()"
                cursor="pointer"
              >
                mdi-content-copy
              </v-icon>
              </v-text-field>
            </v-flex>
            <v-flex v-if="user.partner_program_policy_accepted" md12 sm12 class="d-flex align-center">
              <v-text-field
                v-if="user.partner_balance_hold <= 0"
                v-model="user.partner_balance"
                :label="$t('employers.partner_balance')"
                readonly
                outlined
                hide-details
              >
              </v-text-field>
              <v-text-field
                v-else
                v-model="user.partner_balance_hold"
                :label="$t('employers.partner_balance_to_payout')"
                disabled
                readonly
                outlined
                hide-details
              >
              </v-text-field>
              <v-btn
                color="info"
                @click="payoutPartnerBalance()"
                :loading="isLoadingPayoutPartnerBalance"
                :disabled="user.partner_balance <= 0"
                class="ml-2"
                >{{ $t("employers.payout_partner_balance")}}
              </v-btn>
            </v-flex>
            <v-flex v-if="!user.partner_program_policy_accept" md12 sm12 class="d-flex align-center justify-center my-3">
              <v-btn
                color="info"
                @click="partner_program_policy_accept_dialog = true"
                :block="isMobile"
                >{{ $t("employers.partner_program_policy_accept")}}
              </v-btn>
            </v-flex>
            <v-flex v-if="user.partner_program_policy_accept && !user.partner_program_policy_accepted" md12 sm12 class="d-flex align-center justify-center">
              <v-alert
                type="warning"
                :value="true"
                dismissible
                border="left"
                elevation="2"
                icon="mdi-alert"
                class="mt-3"
              >
                {{ $t("employers.partner_program_policy_accepted_not_approved") }}
              </v-alert>
            </v-flex>
              </v-layout>
            </v-tab-item>

            <!-- Вкладка 4: Настройки -->
            <v-tab-item>
              <v-layout row wrap class="mt-4 pl-3">
                <!-- Каналы уведомлений (доступно всем ролям) -->
                <v-flex md12>
                  <v-subheader class="px-0">{{ $t("user_settings.notifications") }}</v-subheader>
                  <v-card flat class="mb-4" color="transparent">
                    <v-card-text class="px-0 py-0">
                      <v-switch
                        v-model="user_setting.notify_email"
                        :label="$t('user_settings.notify_email')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.notify_telegram"
                        :label="$t('user_settings.notify_telegram')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.notify_push"
                        :label="$t('user_settings.notify_push')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- FT-188: необязательные письма компании на мой адрес -->
                <v-flex md12>
                  <v-subheader class="px-0">{{ $t("email_opt_outs.mine.title") }}</v-subheader>
                  <my-email-opt-outs class="mb-4"></my-email-opt-outs>
                </v-flex>

                <!-- Уведомления -->
                <v-flex v-if="!isAgent" md12>
                  <v-subheader class="px-0">{{ $t("user_settings.push_app") }}</v-subheader>
                  <v-card flat class="mb-4" color="transparent">
                    <v-card-text class="px-0 py-0">
                      <v-switch
                        v-model="user_setting.new_booking_push"
                        :label="$t('user_settings.new_booking_push')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.new_booking_sound"
                        :label="$t('user_settings.new_booking_sound')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.new_message_push"
                        :label="$t('user_settings.new_message_push')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.new_message_sound"
                        :label="$t('user_settings.new_message_sound')"
                        @change="updateUserSetting()"
                        hide-details
                      ></v-switch>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- Подключить Telegram -->
                <v-flex v-if="!isAgent" md12>
                  <v-subheader class="px-0">{{ $t("users.connect_telegram") }}</v-subheader>
                  <v-card flat class="mb-4" color="transparent">
                    <v-card-text class="px-0 py-2">
                      <v-btn color="primary" @click="toTelegram(user.email)">
                        {{ $t("users.connect") }}
                        <svg
                          class="mx-1"
                          width="24px"
                          height="24px"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xml:space="preserve"
                          xmlns:serif="http://www.serif.com/"
                          style="
                            fill-rule: evenodd;
                            clip-rule: evenodd;
                            stroke-linejoin: round;
                            stroke-miterlimit: 1.41421;
                          "
                        >
                          <path
                            id="telegram-1"
                            d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"
                          />
                        </svg>
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <!-- Настройки интерфейса -->
                <v-flex v-if="!isAgent" md12>
                  <v-subheader class="px-0">{{ $t("user_settings.interface_settings") }}</v-subheader>
                  <v-card flat class="mb-4" color="transparent">
                    <v-card-text class="px-0 py-0">
                      <v-switch
                        v-model="user_setting.dark_theme"
                        :label="$t('user_settings.dark_theme')"
                        @change="setTheme()"
                        hide-details
                      ></v-switch>
                      <!-- FT-170 STEP-12: показан = !hide_stage_card (CTR-05) — тумблер
                           инвертирует поле, поэтому не голый v-model на user_setting,
                           а computed с get/set. -->
                      <v-switch
                        v-model="showStageCard"
                        :label="$t('user_settings.stage_card')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.show_icons_on_calendar"
                        :label="$t('user_settings.show_icons_on_calendar')"
                        @change="updateUserSetting()"
                        hide-details
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.show_repair_on_main"
                        :label="$t('user_settings.show_repairs_on_main')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.show_store_place_on_main"
                        :label="$t('user_settings.show_store_places_on_main')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.show_to_on_main"
                        :label="$t('user_settings.show_to_on_main')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.show_tire_on_main"
                        :label="$t('user_settings.show_tire_on_main')"
                        @change="updateUserSetting()"
                        hide-details
                        class="mb-2"
                      ></v-switch>
                      <v-switch
                        v-model="user_setting.short_client_view"
                        :label="$t('user_settings.short_client_view')"
                        @change="updateUserSetting()"
                        hide-details
                      ></v-switch>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <!-- Вкладка 5 (FT-155): ключи агента -->
            <v-tab-item v-if="canHaveAgentTokens">
              <v-layout row wrap class="mt-4">
                <v-flex md12>
                  <agent-access-tokens />
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs-items>
        </v-container>
      </v-card-text>
      <!-- Вкладка ключей агента живёт своими действиями: общий «Сохранить» профиля к ней не относится -->
      <v-card-actions v-if="!agentTokensTabActive">
        <v-spacer></v-spacer>
        <v-btn
          id="registration-step-5"
          class="mb-3"
          color="success"
          data-testid="profile-save-btn"
          @click="saveUser()"
          >{{ $t("custom.save")
          }}<v-icon class="ml-1">
            mdi-content-save-check-outline
          </v-icon></v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="showConfirmSignin"
      :retain-focus="false"
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("custom.approve") }}</v-toolbar-title>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-card-text>
              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                :type="show1 ? 'text' : 'password'"
                name="input-10-1"
                :hint="$t('users.password_length')"
                counter
                @click:append="show1 = !show1"
                data-cy="password"
                :label="$t('users.password')"
                required
              ></v-text-field>
            </v-card-text>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            @click="showConfirmSignin = false"
            data-cy="submit"
            block
            color="primary"
            >{{ $t("custom.approve_2") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="partner_program_policy_accept_dialog"
      :retain-focus="false"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <v-toolbar dark color="primary">
            <v-toolbar-title>{{ $t("employers.partner_program_policy_accept_title") }}</v-toolbar-title>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <p>{{ $t("employers.partner_program_policy_accept_text") }}</p>
          <p class="text-center mt-2"><a :href="$t('employers.partner_program_policy_link')" target="_blank">{{ $t("employers.partner_program_policy_link_text") }}</a></p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="partnerProgramPolicyAccept()"
            color="primary"
            class="mr-2"
            :loading="isLoadingPartnerProgramPolicyAccept"
            >{{ $t("custom.approve_2") }}</v-btn
          >
          <v-btn
            @click="partner_program_policy_accept_dialog = false"
            color="secondary"
            >{{ $t("custom.close") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { Capacitor } from "@capacitor/core";
import { copyToClipboard as copyTextToClipboard } from '@/utils/clipboard';
import UppyUserAvatar from "../../../plugins/uppy_user_avatar";
import AgentAccessTokens from "./AgentAccessTokens.vue";
import MyEmailOptOuts from "./MyEmailOptOuts.vue";
import PinForm from "@/components/deviceLock/PinForm.vue"; // FT-191
import passkeyEnroll from "@/mixins/passkeyEnroll";
import PhoneField from "@/components/common/PhoneField.vue";
import { defaultPhoneCountry } from "@/lib/phone/defaultCountry";
import { phoneFieldsAreValid } from "@/lib/phone/fieldValidation";

// Глубокая копия JSON-данных API: форма не должна делить со стором ни одного объекта.
const copy = (value) => JSON.parse(JSON.stringify(value));

export default {
  mixins: [passkeyEnroll],
  data() {
    return {
      user: {},
      // Аватар, который браузер не декодирует (HEIC/TIFF в Chrome), — буква вместо вечного спиннера.
      avatarFailed: false,
      email: null,
      password: null,
      user_setting: {},
      showConfirmSignin: false,
      show1: false,
      account: {
        cash: 0,
        cashless: 0,
      },
      locales: [
        { text: "English", value: "en" },
        { text: "Русский", value: "ru" },
        { text: "Português (Portugal)", value: "pt" },
        { text: "Português (Brasil)", value: "pt-BR" },
        { text: "Српски", value: "sr" },
        { text: "Thai", value: "th" },
        { text: "Ελληνικά", value: "el" },
        { text: "Hrvatski", value: "hr" },
        { text: "Turkish", value: "tr" },
        { text: "French", value: "fr" },
        { text: "German", value: "de" },
        { text: "Spanish", value: "es" },
        { text: "Italian", value: "it" },
        { text: "Indonesian", value: "id" },
        { text: "Polski", value: "pl" },
        { text: "Română", value: "ro" },
      ],
      select_locale: this.$i18n.locale,
      referral_link: null,
      referral_link_landing: null,
      goDark: false,
      showEdit: false,
      partner_program_policy_accept_dialog: false,
      isLoadingPayoutPartnerBalance: false,
      isLoadingPartnerProgramPolicyAccept: false,
      isLoading: false,
      isMobile: false,
      activeTab: 0,
      error: "",
      // Passkeys (passkeySupported/passkeyPlatformAvailable/passkeyRegistering — из mixins/passkeyEnroll)
      passkeys: [],
      passkeyDeleting: null,
      // Password change
      passwordForm: {
        current: "",
        new: "",
        confirm: "",
      },
      passwordChanging: false,
      invalidatingSessions: false,
      newPasswordTouched: false,
      passwordConfirmTouched: false,
      showCurrentPassword: false,
      showNewPassword: false,
      // Email change
      emailForm: {
        password: "",
        newEmail: "",
        code: "",
        maskedEmail: "",
      },
      emailChanging: false,
      emailChangeRequested: false,
      showEmailPassword: false,
    };
  },
  async created() {
    // Проверяем поддержку Passkeys
    this.checkPasskeySupport();
    
    let self = this;
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/user_info`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          // Форма правит свою копию: при общей со стором ссылке v-model на user.* / user_setting.*
          // писал несохранённый ввод прямо в currentUser (его читают AppHeader, Home, CarCard,
          // Map, сохраняет vuex-persistedstate), а после замены currentUser новым объектом
          // (/me.json при смене филиала) сохранённые правки в стор уже не попадали. Стор
          // меняется только после успешного сохранения — новым объектом, см. commitCurrentUser.
          this.user = copy(response.data);
          this.$store.commit("setCurrentUser", response.data);
          this.referral_link = `https://web.rentprog.${this.$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/signup?ref=${this.user.referral_code}`;
          this.referral_link_landing = `https://rentprog.${this.$root.$i18n.locale == 'ru' ? 'ru' : 'com'}/?ref=${this.user.referral_code}`;

          this.account = this.user.account;
          this.user_setting = this.user.user_setting || {};
          
          // Загружаем Passkeys после получения данных пользователя
          this.loadPasskeys();
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.load_user"));
          console.log(error);
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  mounted: function () {
    if (this.$tours["registrationTour"]) {
      this.$tours["registrationTour"].nextStep();
    }
    let self = this;
  },
  computed: {
    // FT-170 STEP-12: показан = !hide_stage_card. Сеттер через $set — user_setting
    // приходит с сервера объектом без гарантированного заранее ключа hide_stage_card
    // (см. project_vue2_vmodel_compiles_to_set — примитивный дефолт без $set не реактивен).
    showStageCard: {
      get() {
        return !this.user_setting.hide_stage_card;
      },
      set(value) {
        this.$set(this.user_setting, "hide_stage_card", !value);
      },
    },
    // Вкладка ключей — пятая (индекс 4), есть только при canHaveAgentTokens; порядок вкладок держит
    // ProfileAgentTokensTab.spec.js (вставка вкладки перед ней роняет спек).
    agentTokensTabActive() {
      return this.canHaveAgentTokens && this.activeTab === 4;
    },
    // FT-155 REQ-10 / DEC-06: у partner и agent ключей нет — вкладку не показываем.
    // PIN нужен только сотрудникам компании, включившей блокировку общих компьютеров (REQ-01).
    canHavePin() {
      const mainCompany = this.$store.getters.getMainCompany;
      return !!this.$store.getters.isStaff && !!(mainCompany && mainCompany.pin_lock_enabled);
    },
    canHaveAgentTokens() {
      const current = this.$store.getters.getCurrentUser;
      const role = current && current.role;
      return !!role && !["partner", "agent"].includes(role);
    },
    main_company() {
      if (this.$store.getters.getMainCompany) {
        return this.$store.getters.getMainCompany;
      }
      return undefined;
    },
    phoneDefaultCountry() {
      const storeCompany = this.$store.getters.getCompany;
      return defaultPhoneCountry({ company: storeCompany && storeCompany.company });
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    canChangePassword() {
      const pw = this.passwordForm.new;
      return this.passwordForm.current &&
             pw &&
             this.passwordForm.confirm &&
             pw === this.passwordForm.confirm &&
             pw.length >= 8 &&
             /[A-Z]/.test(pw) &&
             /[a-z]/.test(pw) &&
             /\d/.test(pw);
    },
    canRequestEmailChange() {
      return this.emailForm.password &&
             this.emailForm.newEmail &&
             this.isValidEmail(this.emailForm.newEmail);
    },
    passwordRules() {
      return [
        v => !!v || this.$t("account_security.password_required"),
        v => (v && v.length >= 8) || this.$t("account_security.password_min_length"),
        v => /[A-Z]/.test(v) || this.$t("account_security.password_no_uppercase"),
        v => /[a-z]/.test(v) || this.$t("account_security.password_no_lowercase"),
        v => /\d/.test(v) || this.$t("account_security.password_no_digit"),
      ];
    },
    emailRules() {
      return [
        v => !!v || this.$t("account_security.email_required"),
        v => this.isValidEmail(v) || this.$t("account_security.invalid_email"),
      ];
    },
  },
  watch: {
    select_locale() {
      this.$i18n.locale = this.select_locale;
      this.$root.$i18n.locale = this.select_locale;
      localStorage.setItem("lang", this.select_locale);
      this.user.locale = this.select_locale;
      this.saveLocale();
    },
  },
  methods: {
    saveUser() {
      const currentEmail = this.$store.getters.getCurrentUser.email;
      if (!this.user.email || !currentEmail) return;
      if (!phoneFieldsAreValid(this.$refs && this.$refs.phoneField)) return;
      this.isLoading = true;
      // Снимок отправленного: в стор уходит он, а не то, что набрано за время запроса.
      const sent = {
        name: this.user.name,
        last_name: this.user.last_name,
        middle_name: this.user.middle_name,
        first_name: this.user.first_name,
        phone: this.user.phone,
        telegram_id: this.user.telegram_id,
        locale: this.user.locale,
        traccar_password: this.user.traccar_password,
      };
      this.axios
        .patch(
          `/api/v1/users/${this.user.id}`,
          { users: sent },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          this.commitCurrentUser(sent);
          this.showEdit = false;
          this.$notify(this.$t("users.profile_updated"), "", "success", 3000);
        })
        .catch((error) => {
          if (error.response?.status == 406) {
            this.$notify(this.$t("errors.error"), this.$t("errors.phone_already_exists"), "error", 5000);
          } else {
            this.setError(error, this.$t("errors.profile_update"));
          }
        })
        .finally(() => (this.isLoading = false));
    },
    // currentUser меняется только новым объектом: прежний из стора + подтверждённые сервером
    // поля (снимок отправленного или ответ API, но не объекты формы). Пока шёл запрос, могли
    // выйти из аккаунта (в том числе в другой вкладке — setCurrentUser/unsetCurrentUser общие):
    // тогда в сторе другой пользователь или пусто, и setCurrentUser вернул бы signedIn.
    commitCurrentUser(fields) {
      const current = this.$store.getters.getCurrentUser;
      if (!current || current.id !== this.user.id) return;
      this.$store.commit("setCurrentUser", { ...current, ...fields });
    },
    payoutPartnerBalance() {
      if (this.user.currency_partner_program == "RUB" && this.user.partner_balance < 5000) {
        this.$notify(this.$t("employers.payout_partner_balance_not_enough"), "", "error", 3000);
        return;
      }
      if (this.user.currency_partner_program == "EUR" && this.user.partner_balance < 50) {
        this.$notify(this.$t("employers.payout_partner_balance_not_enough"), "", "error", 3000);
        return;
      }

      this.isLoadingPayoutPartnerBalance = true;
      let self = this;
      this.axios
        .post(
          `/api/v1/payout_partner_balance`,
          {
            user_id: this.user.id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then(() => {
          const payout = { partner_balance_hold: this.user.partner_balance, partner_balance: 0 };
          Object.assign(this.user, payout);
          this.commitCurrentUser(payout);

          this.$notify(this.$t("other.success"), "", "success", 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.profile_update"));
        })
        .finally(() => (self.isLoadingPayoutPartnerBalance = false));
    },
    partnerProgramPolicyAccept() {
      this.isLoadingPartnerProgramPolicyAccept = true;
      let self = this;
      this.axios
        .post(
          `/api/v1/partner_program_policy_accept`,
          {
            user_id: this.user.id,
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.user.partner_program_policy_accept = true;
          this.partner_program_policy_accept_dialog = false;
          // Ответ — current_user без user_setting/account (не форма user_info): сливаем, не заменяем.
          this.commitCurrentUser(response.data);
          this.$notify(this.$t("other.success"), "", "success", 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.profile_update"));
        })
        .finally(() => (self.isLoadingPartnerProgramPolicyAccept = false));
    },
    updateUserSetting() {
      return this.axios
        .patch(
          `/api/v1/update_user_setting`,
          {
            user_setting: {
              new_booking_push: this.user_setting.new_booking_push,
              new_booking_sound: this.user_setting.new_booking_sound,
              new_message_push: this.user_setting.new_message_push,
              new_message_sound: this.user_setting.new_message_sound,
              tech_push: this.user_setting.tech_push,
              insurance_push: this.user_setting.insurance_push,
              show_repair_on_main: this.user_setting.show_repair_on_main,
              show_store_place_on_main:
                this.user_setting.show_store_place_on_main,
              show_to_on_main: this.user_setting.show_to_on_main,
              show_tire_on_main: this.user_setting.show_tire_on_main,
              short_client_view: this.user_setting.short_client_view,
              dark_theme: this.user_setting.dark_theme,
              show_icons_on_calendar: this.user_setting.show_icons_on_calendar,
              remember_login: this.user_setting.remember_login,
              notify_email: this.user_setting.notify_email,
              notify_telegram: this.user_setting.notify_telegram,
              notify_push: this.user_setting.notify_push,
              hide_stage_card: this.user_setting.hide_stage_card,
            },
          },
          {
            headers: {
              Authorization: this.$store.getters.getAuthToken,
            },
          }
        )
        .then((response) => {
          this.$store.commit("setUserSettings", response.data);
          this.commitCurrentUser({ user_setting: response.data });
          this.$notify(this.$t("users.profile_updated"), "", "success", 3000);
        })
        .catch((error) => {
          this.setError(error, this.$t("errors.profile_update"));
        })
        .finally(() => (this.isLoading = false));
    },
    saveRememberLogin() {
      // Сохраняем настройку на сервере
      this.updateUserSetting();
      
      // Управляем localStorage
      if (this.user_setting.remember_login) {
        // Сохраняем логин в localStorage
        localStorage.setItem("rememberedLogin", this.user.email || this.user.phone);
      } else {
        // Удаляем сохраненный логин
        localStorage.removeItem("rememberedLogin");
      }
    },
    saveLocale() {
      let self = this;
      if (this.user.locale) {
        this.isLoading = true;
        const sent = { locale: this.user.locale };
        this.axios
          .patch(
            `/api/v1/users/${this.user.id}`,
            {
              users: sent,
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.commitCurrentUser(sent);
            this.$notify(this.$t("users.profile_updated"), "", "success", 3000);
          })
          .catch((error) => {
            self.setError(error, self.$t("errors.profile_update"));
          })
          .finally(() => (self.isLoading = false));
      }
    },
    setTheme() {
      this.updateUserSetting();
      if (this.user_setting.dark_theme == true) {
        return (this.$vuetify.theme.dark = true);
      } else {
        return (this.$vuetify.theme.dark = false);
      }
    },
    toTelegram(email) {
      let base_64_email = btoa(email);
      window.open(`https://t.me/rentalmanbot?start=${base_64_email}`, "_blank");
    },
    async copyReferralLink() {
      try {
        await copyTextToClipboard(this.referral_link);
        this.$notify(this.$t("custom.copy_success"), "", "success", 3000);
      } catch (error) {
        this.$notify(this.$t("custom.copy_error"), "", "error");
      }
    },
    async copyReferralLinkLanding() {
      try {
        await copyTextToClipboard(this.referral_link_landing);
        this.$notify(this.$t("custom.copy_success"), "", "success", 3000);
      } catch (error) {
        this.$notify(this.$t("custom.copy_error"), "", "error");
      }
    },
    goBack() {
      var numberOfEntries = window.history.length;
      if (numberOfEntries > 2) {
        this.$router.go(-1);
      } else {
        if (
          this.PageData &&
          this.PageData.backCrumb &&
          this.PageData.backCrumb.url
        ) {
          var fpath = this.PageData.backCrumb.url;
          this.$router.push({
            path: fpath,
          });
        } else {
          this.$router.push({ path: "/dashboard" });
        }
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    
    // ===== PASSKEYS ===== (checkPasskeySupport/enrollPasskey — из mixins/passkeyEnroll)
    async loadPasskeys() {
      if (!this.passkeySupported) return;
      
      try {
        const response = await this.axios.get('/api/v1/passkeys', {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        this.passkeys = response.data.passkeys || [];
      } catch (error) {
        console.error('Failed to load passkeys:', error);
      }
    },
    
    // Кнопка «Добавить passkey» в настройках: enroll (mixin) → обновить список.
    async registerPasskey() {
      const ok = await this.enrollPasskey();
      if (ok) await this.loadPasskeys();
    },
    
    async deletePasskey(passkey) {
      const confirmed = await this.$confirm({
        title: this.$t("passkeys.delete_confirm_title"),
        text: this.$t("passkeys.delete_confirm_text", { name: passkey.nickname || this.$t("passkeys.unnamed") }),
        confirmButtonText: this.$t("custom.delete"),
        cancelButtonText: this.$t("custom.cancel"),
      });
      
      if (!confirmed) return;
      
      this.passkeyDeleting = passkey.id;
      
      try {
        await this.axios.delete(`/api/v1/passkeys/${passkey.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        
        this.$notify(this.$t("passkeys.deleted"), "", "success", 3000);
        await this.loadPasskeys();
        
      } catch (error) {
        console.error('Passkey deletion error:', error);
        const errorMessage = error.response?.data?.error || this.$t("passkeys.delete_failed");
        this.$notify(this.$t("errors.error"), errorMessage, "error", 5000);
      } finally {
        this.passkeyDeleting = null;
      }
    },
    
    // ===== CHANGE PASSWORD =====
    async changePassword() {
      // Диалог подтверждения перед сменой пароля
      const confirmed = await this.$confirm({
        title: this.$t("account_security.change_password"),
        text: this.$t("account_security.change_password_confirm"),
        icon: "mdi-lock-reset",
        iconColor: "warning",
        confirmButtonColor: "primary",
      });
      if (!confirmed) return;

      this.passwordChanging = true;
      
      try {
        await this.axios.post('/api/v1/account/change_password', {
          current_password: this.passwordForm.current,
          new_password: this.passwordForm.new,
          password_confirmation: this.passwordForm.confirm,
          encrypted_password_digest: this.passwordForm.new,
        }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        
        // Очищаем токен и перенаправляем на страницу входа
        this.$store.commit("unsetCurrentUser");
        
      } catch (error) {
        console.error('Password change error:', error);
        const errorMessage = error.response?.data?.error || this.$t("errors.error");
        this.$notify(this.$t("errors.error"), errorMessage, "error", 5000);
        this.passwordChanging = false;
      }
    },
    
    // ===== INVALIDATE ALL SESSIONS =====
    async invalidateAllSessions() {
      const confirmed = await this.$confirm({
        title: this.$t("account_security.invalidate_all_sessions"),
        text: this.$t("account_security.invalidate_all_sessions_confirm"),
        icon: "mdi-logout",
        iconColor: "error",
        confirmButtonColor: "error",
      });
      if (!confirmed) return;

      this.invalidatingSessions = true;
      
      try {
        await this.axios.post('/api/v1/account/invalidate_all_sessions', {}, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        
        // Очищаем токен и перенаправляем на страницу входа
        this.$store.commit("unsetCurrentUser");
        
      } catch (error) {
        console.error('Invalidate all sessions error:', error);
        const errorMessage = error.response?.data?.error || this.$t("errors.error");
        this.$notify(this.$t("errors.error"), errorMessage, "error", 5000);
        this.invalidatingSessions = false;
      }
    },

    // ===== CHANGE EMAIL =====
    async requestEmailChange() {
      this.emailChanging = true;
      
      try {
        const response = await this.axios.post('/api/v1/account/request_email_change', {
          current_password: this.emailForm.password,
          new_email: this.emailForm.newEmail,
        }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        
        this.emailForm.maskedEmail = response.data.masked_email;
        this.emailChangeRequested = true;
        this.$notify(this.$t("account_security.code_sent"), "", "success", 3000);
        
      } catch (error) {
        console.error('Email change request error:', error);
        const errorMessage = error.response?.data?.error || this.$t("errors.error");
        this.$notify(this.$t("errors.error"), errorMessage, "error", 5000);
      } finally {
        this.emailChanging = false;
      }
    },
    
    async confirmEmailChange() {
      this.emailChanging = true;
      
      try {
        const response = await this.axios.post('/api/v1/account/confirm_email_change', {
          code: this.emailForm.code,
        }, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
        
        // Новый email — в форму и новым объектом в стор.
        this.user.email = response.data.new_email;
        this.commitCurrentUser({ email: response.data.new_email });
        
        this.$notify(this.$t("account_security.email_changed"), "", "success", 3000);
        
        // Сбрасываем форму
        this.resetEmailForm();
        
      } catch (error) {
        console.error('Email change confirm error:', error);
        const errorMessage = error.response?.data?.error || this.$t("errors.error");
        const remaining = error.response?.data?.remaining_attempts;
        
        if (remaining !== undefined) {
          this.$notify(this.$t("errors.error"), `${errorMessage} (${this.$t("account_security.attempts_left")}: ${remaining})`, "error", 5000);
        } else {
          this.$notify(this.$t("errors.error"), errorMessage, "error", 5000);
        }
      } finally {
        this.emailChanging = false;
      }
    },
    
    async cancelEmailChange() {
      try {
        await this.axios.post('/api/v1/account/cancel_email_change', {}, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        });
      } catch (error) {
        console.error('Cancel email change error:', error);
      }
      
      this.resetEmailForm();
    },
    
    resetEmailForm() {
      this.emailForm = { password: "", newEmail: "", code: "", maskedEmail: "" };
      this.emailChangeRequested = false;
    },
    
    isValidEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },

    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleDateString(this.$i18n.locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
  components: {
    UppyUserAvatar,
    AgentAccessTokens,
    MyEmailOptOuts,
    PinForm,
    PhoneField,
  },
};
</script>
